import React, { useState } from "react";
import { useSearchParams } from 'react-router-dom';

import SidebarFilter from "../Components/SidebarFilter";
import ProductGrid from "../shared/ProductGrid";

export default function CollectionsPage() {
    const [searchParams] = useSearchParams();
    const category = searchParams.get("category"); // specific category or null for all
    const searchQuery = searchParams.get("search"); // search query
    const [filters, setFilters] = useState({});
    const [count, setCount] = useState(0);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [sortBy, setSortBy] = useState("newest");

    const title = searchQuery
        ? `Search results for "${searchQuery}"`
        : (category ? category : "All Collections");

    // Handle filter removal
    const removeFilter = (key) => {
        const newFilters = { ...filters };
        if (key === 'price') {
            delete newFilters.min;
            delete newFilters.max;
        }
        setFilters(newFilters);
    };

    // Check if any filters are active (price only now)
    const hasActiveFilters = filters.min !== undefined || filters.max !== undefined;

    return (
        <div className="collections-page light-section min-vh-100">
            {/* Hero Banner Section */}
            <div className="page-banner position-relative">
                <div className="glowing-orb primary top-50 start-50 translate-middle" style={{ width: '400px', height: '400px', opacity: 0.5 }}></div>
                <div className="container position-relative z-1 text-center">
                    <h1 className="page-banner-title text-white">{title}</h1>
                    <div className="page-banner-breadcrumb text-light opacity-75">
                        <a href="/" className="text-light text-decoration-none">Home</a> <span>/</span> Collections
                        {category && <> <span>/</span> {category}</>}
                    </div>
                    {searchQuery && (
                        <p className="mt-2 text-light opacity-75 small">
                            Browse through your search results for "{searchQuery}"
                        </p>
                    )}
                </div>
            </div>

            <div className="container section-padding px-3 px-sm-4">
                <div className="collections-layout">
                    {/* Sidebar Filter - handles both desktop sidebar and mobile drawer */}
                    <SidebarFilter
                        onChange={setFilters}
                        mobileOpen={mobileOpen}
                        onClose={() => setMobileOpen(false)}
                        sortBy={sortBy}
                        onSortChange={setSortBy}
                    />

                    <main className="collections-main">
                        {/* Header with Title, Count, and Sort */}
                        <div className="collection-header-row border-bottom border-light mb-3 mb-md-4 pb-2 d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
                            <div className="collection-header-left">
                                <h2 className="section-heading text-dark mb-1">{title}</h2>
                                <span className="collection-count text-muted-dark small fs-6">{count} masterpieces</span>
                            </div>
                            <div className="w-100 w-sm-auto d-flex">
                                <div className="d-flex justify-content-start w-100">
                                    {/* Mobile Filter Toggle */}
                                    <div className="mobile-filter-toggle w-100 w-sm-auto justify-content-center" onClick={() => setMobileOpen(true)}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
                                        </svg>
                                        <span className="ms-2">Filters</span>
                                        {hasActiveFilters && <span className="filter-count-badge bg-primary ms-1">●</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Active Filters Display */}
                        {hasActiveFilters && (
                            <div className="active-filters white-card p-2 p-sm-3 rounded-3 mb-3 mb-md-4 d-flex align-items-center flex-wrap gap-2 gap-md-3">
                                <span className="active-filters-label text-dark fw-bold small fs-6">Active Filters:</span>
                                <div className="filter-chips d-flex flex-wrap gap-2">
                                    {(filters.min !== undefined || filters.max !== undefined) && (
                                        <span className="filter-chip bg-primary text-white px-2 px-sm-3 py-1 rounded-pill d-flex align-items-center gap-2 small">
                                            ₹{filters.min || 0} - ₹{filters.max || '∞'}
                                            <button
                                                className="chip-remove btn-close btn-close-white"
                                                onClick={() => removeFilter('price')}
                                                aria-label="Remove price filter"
                                                style={{ fontSize: '0.65rem' }}
                                            ></button>
                                        </span>
                                    )}
                                </div>
                                <button
                                    className="clear-all-filters btn btn-link text-dark text-decoration-none ms-auto p-0 small fw-bold"
                                    onClick={() => setFilters({})}
                                >
                                    Clear All
                                </button>
                            </div>
                        )}

                        <ProductGrid
                            categoryName={category}
                            filters={filters}
                            onCountChange={setCount}
                            sortBy={sortBy}
                            searchQuery={searchQuery}
                        />
                    </main>
                </div>
            </div>
        </div>
    );
}
